export default __webpack_public_path__ + "static/media/meetingdown.7f1a47c8.svg";